module.exports = __webpack_public_path__ + "c2dbcee5.png";